import { apiRequest } from '../apiRequest';

export const getTelegramActionsApi = async () => {
  return apiRequest('/admin/notification/telegram-destinations/actions', {
    method: 'GET',
    defaultErrorMessage: 'Failed to load Telegram actions',
  });
};
